module.exports = __webpack_public_path__ + "media/asset/images/Image-4680626b2316523e13f244c746dc31bb.png";